import { PagedSearch } from '../../shared/model/paged-search.model';

export class CertificationActivitySearchDto extends PagedSearch {
  public ProfileId: number;
  public ActivityType: number;
  public IncludeCE_CreditType: boolean;
  public IncludeCertificationActivitySource: boolean;

  public constructor() {
    super();

    this.ProfileId = 0;
    this.ActivityType = 0;
    this.IncludeCE_CreditType = false;
    this.IncludeCertificationActivitySource = false;
  }
}
